(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aigo-bundle"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aigo-bundle').forEach(function(section) {
  section.querySelectorAll('.tab').forEach(function(tab, i) {
    tab.addEventListener('click', function() {
      section.querySelectorAll('.tab').forEach(function(t) { t.classList.remove('on'); });
      tab.classList.add('on');
      section.querySelectorAll('.aigo-bundle__grid').forEach(function(g, j) {
        g.style.display = j === i ? '' : 'none';
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-countdown"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.aigo-countdown').forEach(function(section) {
    var endAttr = section.getAttribute('data-end-time');
    if (!endAttr) return;
    var end = new Date(endAttr).getTime();
    if (isNaN(end)) return;
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var pad = function(n) { return String(n).padStart(2, '0'); };
      var dEl = section.querySelector('[data-d]');
      var hEl = section.querySelector('[data-h]');
      var mEl = section.querySelector('[data-m]');
      var sEl = section.querySelector('[data-s]');
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-faq"] && !Shopify.designMode) return;
  try {
    
  // Accordion toggle with max-height animation (works on both desktop and mobile)
  document.querySelectorAll('.qa__q').forEach(function(q) {
    q.addEventListener('click', function() {
      var qa = q.closest('.qa');
      var a = qa.querySelector('.qa__a');
      var open = qa.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });

  // Desktop: category nav active-state on scroll
  var cats = Array.from(document.querySelectorAll('.faqcat[id]'));
  var navLinks = Array.from(document.querySelectorAll('.faqnav a'));
  if (cats.length) {
    function syncNav() {
      var y = window.scrollY + 140;
      var active = cats[0];
      for (var i = 0; i < cats.length; i++) {
        if (cats[i].offsetTop <= y) active = cats[i];
      }
      navLinks.forEach(function(a) {
        a.classList.toggle('on', a.getAttribute('href') === '#' + active.id);
      });
    }
    window.addEventListener('scroll', syncNav, { passive: true });
    syncNav();
  }

  // Mobile: category chip switching
  document.querySelectorAll('.mfq-chip').forEach(function(c) {
    c.addEventListener('click', function() {
      document.querySelectorAll('.mfq-chip').forEach(function(x) { x.classList.remove('on'); });
      c.classList.add('on');
      document.querySelectorAll('.mfq-cat').forEach(function(s) { s.style.display = 'none'; });
      var sec = document.getElementById('mcat-' + c.dataset.cat);
      if (sec) {
        sec.style.display = '';
        sec.querySelectorAll('.qa.open .qa__a').forEach(function(a) { a.style.maxHeight = a.scrollHeight + 'px'; });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── Mobile drawer open/close ── */
  var btn   = document.getElementById('aigo-menu-btn');
  var scrim = document.getElementById('aigo-menu-scrim');
  var drawer = document.getElementById('aigo-menu-drawer');
  var deskBtn = document.getElementById('aigo-desktop-menu-btn');
  function closeAllAccordions() {
    if (!drawer) return;
    drawer.querySelectorAll('.mm-acc__btn[aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var sub = document.getElementById(b.dataset.target);
      if (sub) sub.hidden = true;
    });
  }

  function openMenu() {
    if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
    if (scrim)  scrim.classList.add('show');
    document.body.style.overflow = 'hidden';
    if (btn)    btn.setAttribute('aria-expanded', 'true');
    if (deskBtn) deskBtn.setAttribute('aria-expanded', 'true');
    if (deskBtn) deskBtn.setAttribute('aria-label', 'Close menu');
  }

  function closeMenu() {
    if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
    if (scrim)  scrim.classList.remove('show');
    document.body.style.overflow = '';
    if (btn)    btn.setAttribute('aria-expanded', 'false');
    if (deskBtn) deskBtn.setAttribute('aria-expanded', 'false');
    if (deskBtn) deskBtn.setAttribute('aria-label', 'Open menu');
    closeAllAccordions();
  }

  btn   && btn.addEventListener('click', openMenu);
  deskBtn && deskBtn.addEventListener('click', function() {
    drawer && drawer.classList.contains('open') ? closeMenu() : openMenu();
  });
  scrim && scrim.addEventListener('click', closeMenu);

  /* Close button rendered inside the snippet */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#aigo-menu-close')) closeMenu();
  });

  /* ── Mobile accordion ── */
  document.addEventListener('click', function (e) {
    var accBtn = e.target.closest('.mm-acc__btn[data-target]');
    if (accBtn && drawer && drawer.contains(accBtn)) {
      var sub = document.getElementById(accBtn.dataset.target);
      var expanded = accBtn.getAttribute('aria-expanded') === 'true';
      accBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (sub) sub.hidden = expanded;
    }
  });

  // ── Account dropdown toggle ──
  document.querySelectorAll('.hdr__trig').forEach(function(trig) {
    var wrap = trig.closest('.hdr__acct');
    var dd   = wrap && wrap.querySelector('.dd');
    if (!dd) return;
    trig.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = dd.hidden;
      // Close any other open dropdowns first
      document.querySelectorAll('.hdr__acct .dd').forEach(function(d) { d.hidden = true; });
      document.querySelectorAll('.hdr__trig').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
        t.classList.remove('is-open');
      });
      if (isOpen) {
        dd.hidden = false;
        trig.setAttribute('aria-expanded', 'true');
        trig.classList.add('is-open');
      }
    });
  });
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.hdr__acct')) {
      document.querySelectorAll('.hdr__acct .dd').forEach(function(d) { d.hidden = true; });
      document.querySelectorAll('.hdr__trig').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
        t.classList.remove('is-open');
      });
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hdr__acct .dd').forEach(function(d) { d.hidden = true; });
      document.querySelectorAll('.hdr__trig').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
        t.classList.remove('is-open');
      });
      if (drawer && drawer.classList.contains('open')) closeMenu();
    }
  });


})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-home-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq__q').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq__item');
      const isOpen = item.classList.contains('open');
      item.closest('.faqlist').querySelectorAll('.faq__item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-main-article"] && !Shopify.designMode) return;
  try {
    
  // Mobile reading progress bar
  var artProg = document.getElementById('art-prog');
  if (artProg) {
    window.addEventListener('scroll', function() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0) {
        artProg.style.width = Math.min(100, Math.max(4, (window.scrollY / h) * 100)) + '%';
      }
    }, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-main-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  var debounceTimers = {};

  function setButtonsDisabled(disabled) {
    document.querySelectorAll('.qstep-minus, .qstep-plus').forEach(function(btn) {
      btn.disabled = disabled;
    });
  }

  function updateQty(line, qty) {
    setButtonsDisabled(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function(res) { return res.json(); })
    .then(function() { window.location.reload(); })
    .catch(function(err) {
      console.error('Cart update error', err);
      setButtonsDisabled(false);
    });
  }

  function debouncedUpdateQty(line, qty) {
    clearTimeout(debounceTimers[line]);
    debounceTimers[line] = setTimeout(function() {
      delete debounceTimers[line];
      updateQty(line, qty);
    }, 800);
  }

  // desktop qty steppers
  document.querySelectorAll('.qstep-minus').forEach(function(btn) {
    var qstep = btn.closest('.qstep');
    if (!qstep) return;
    btn.addEventListener('click', function() {
      var line  = parseInt(qstep.dataset.line, 10);
      var input = qstep.querySelector('.qstep-input');
      var cur   = parseInt(input.value != null ? input.value : input.textContent, 10);
      var qty   = Math.max(0, cur - 1);
      if (input.tagName === 'INPUT') input.value = qty; else input.textContent = qty;
      debouncedUpdateQty(line, qty);
    });
  });

  document.querySelectorAll('.qstep-plus').forEach(function(btn) {
    var qstep = btn.closest('.qstep');
    if (!qstep) return;
    btn.addEventListener('click', function() {
      var line  = parseInt(qstep.dataset.line, 10);
      var input = qstep.querySelector('.qstep-input');
      var cur   = parseInt(input.value != null ? input.value : input.textContent, 10);
      var qty   = cur + 1;
      if (input.tagName === 'INPUT') input.value = qty; else input.textContent = qty;
      debouncedUpdateQty(line, qty);
    });
  });

  document.querySelectorAll('input.qstep-input').forEach(function(input) {
    input.addEventListener('change', function() {
      var line = parseInt(input.dataset.line, 10);
      updateQty(line, Math.max(0, parseInt(input.value, 10)));
    });
  });

  document.querySelectorAll('.cline__rm').forEach(function(btn) {
    btn.addEventListener('click', function() {
      updateQty(parseInt(btn.dataset.line, 10), 0);
    });
  });

  // ── Address persistence (survives page reload on qty change) ──────────────
  var ADDR_KEY = 'aigo_selected_addr';

  function saveNewAddress(prefix) {
    function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
    try {
      sessionStorage.setItem(ADDR_KEY, JSON.stringify({
        isNew:    true,
        first:    val(prefix + '-first'),
        last:     val(prefix + '-last'),
        addr1:    val(prefix + '-addr1'),
        addr2:    val(prefix + '-addr2'),
        city:     val(prefix + '-city'),
        province: val(prefix + '-state'),
        zip:      val(prefix + '-zip'),
        country:  val(prefix + '-country'),
      }));
    } catch(e) { /* storage unavailable — degrade gracefully */ }
  }

  function saveCardAddress(cardId) {
    try {
      sessionStorage.setItem(ADDR_KEY, JSON.stringify({ isNew: false, cardId: cardId }));
    } catch(e) { /* storage unavailable — degrade gracefully */ }
  }

  function clearSavedAddress() {
    sessionStorage.removeItem(ADDR_KEY);
  }

  function getSavedAddress() {
    try { return JSON.parse(sessionStorage.getItem(ADDR_KEY)); } catch(e) { return null; }
  }

  // Fetch shipping rates by reading the current form field values.
  // syncFormFromCard must be called first for saved addresses.
  // Retries if aigo-shipping.js (deferred) hasn't registered window.AigoShipping yet —
  // covers the race on first cart-page visit after navigating from the cart drawer.
  function refreshShipping(attemptsLeft) {
    if (attemptsLeft === undefined) attemptsLeft = 5;
    if (window.AigoShipping && window.AigoShipping.refreshRates) {
      window.AigoShipping.refreshRates();
    } else if (attemptsLeft > 1) {
      setTimeout(function() { refreshShipping(attemptsLeft - 1); }, 100);
    }
  }

  // ── Multi-address picker — desktop ────────────────────────────────────────
  (function() {
    var collapsed  = document.getElementById('co-addr-collapsed');
    var expanded   = document.getElementById('co-addr-expanded');
    var expandBtn  = document.getElementById('co-addr-expand');
    var addrForm   = document.getElementById('co-addr-form');
    var addrList   = expanded && expanded.querySelector('.addr-list');
    if (!collapsed || !expanded || !expandBtn) return;

    // Collapse the address picker UI. Does NOT trigger a rate fetch —
    // each caller is responsible for calling refreshShipping() after.
    function collapseAddr() {
      expanded.hidden  = true;
      collapsed.hidden = false;
    }
    function expandAddr() {
      expanded.hidden  = false;
      collapsed.hidden = true;
    }
    expandBtn.addEventListener('click', expandAddr);

    // Populate hidden form fields from a saved card's data-* attributes.
    // These fields are read by draft-order.js via getAddress() and by
    // aigo-shipping.js via refreshShipping(). Province options are rebuilt
    // from the country's data-provinces attribute to ensure correct values.
    function syncFormFromCard(card) {
      var d = card.dataset;
      var set = function(id, val) { var el = document.getElementById(id); if (el) el.value = val || ''; };
      set('co-first',  d.first);
      set('co-last',   d.last);
      set('co-addr1',  d.addr1);
      set('co-addr2',  d.addr2);
      set('co-city',   d.city);
      set('co-zip',    d.zip);

      var countryEl = document.getElementById('co-country');
      var stateEl   = document.getElementById('co-state');

      if (countryEl && d.country) {
        var countryOpt = Array.from(countryEl.options).find(function(o) {
          return o.value === d.country || o.textContent.trim() === d.country;
        });
        if (countryOpt) countryEl.value = countryOpt.value;
      }

      if (stateEl && countryEl) {
        var selOpt = countryEl.options[countryEl.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(selOpt && selOpt.dataset.provinces || '[]'); } catch (e) {}
        stateEl.innerHTML = '';
        var wrap = stateEl.closest('.fld');
        if (provinces.length === 0) {
          if (wrap) wrap.style.display = 'none';
        } else {
          if (wrap) wrap.style.display = '';
          provinces.forEach(function(p) {
            var opt = document.createElement('option');
            opt.value = p[0];
            opt.textContent = p[1];
            stateEl.appendChild(opt);
          });
          if (d.province) {
            stateEl.value = d.province;
            if (stateEl.value !== d.province) {
              var m = Array.from(stateEl.options).find(function(o) { return o.textContent.trim() === d.province; });
              if (m) stateEl.value = m.value;
            }
          }
        }
      }

      if (window.AigoShipping && window.AigoShipping.cancelPendingFetch) {
        window.AigoShipping.cancelPendingFetch();
      }
    }

    function fillSummary(name, badge, badgeClass, detail) {
      var nameEl   = document.getElementById('co-addr-name');
      var badgeEl  = document.getElementById('co-addr-badge');
      var detailEl = document.getElementById('co-addr-detail');
      if (nameEl)   nameEl.textContent  = name;
      if (detailEl) detailEl.textContent = detail;
      if (badgeEl) {
        badgeEl.textContent  = badge || '';
        badgeEl.className    = badge ? ('addr-card__badge' + (badgeClass ? ' ' + badgeClass : '')) : '';
        badgeEl.style.display = badge ? '' : 'none';
      }
    }

    if (addrList) {
      var reselecting = false;
      addrList.addEventListener('mousedown', function(e) {
        var card = e.target.closest('.addr-card');
        if (!card) return;
        var radio = card.querySelector('input[type="radio"]');
        reselecting = !!(radio && radio.checked && radio.value !== 'new');
      });
      addrList.addEventListener('click', function(e) {
        // Re-click on already-selected card → just collapse, no re-fetch
        if (reselecting) { reselecting = false; collapseAddr(); }
      });
      addrList.addEventListener('change', function(e) {
        var radio = e.target;
        if (radio.type !== 'radio') return;
        addrList.querySelectorAll('.addr-card').forEach(function(c) { c.classList.remove('addr-card--on'); });
        var card = radio.closest('.addr-card');
        if (card) card.classList.add('addr-card--on');

        if (radio.value === 'new') {
          if (addrForm) addrForm.hidden = false;
        } else {
          if (addrForm) addrForm.hidden = true;
          if (card) {
            syncFormFromCard(card);
            saveCardAddress(radio.value);
            var name   = (card.dataset.first || '') + ' ' + (card.dataset.last || '');
            var detail = card.dataset.addr1 +
              (card.dataset.addr2 ? ', ' + card.dataset.addr2 : '') +
              ' · ' + card.dataset.city + ', ' + (card.dataset.province ? card.dataset.province + ' ' : '') + card.dataset.zip + ' · ' + card.dataset.country;
            var badgeEl = card.querySelector('.addr-card__badge');
            var badge   = badgeEl ? badgeEl.textContent : '';
            var badgeClass = badgeEl ? (badgeEl.classList.contains('addr-card__badge--tag') ? 'addr-card__badge--tag' : '') : '';
            fillSummary(name.trim(), badge, badgeClass, detail);
            collapseAddr();
            // Pass address directly from card data — bypasses form field race condition
            refreshShipping();
          }
        }
      });
    }

    // "Use this address" — session-only, no persist
    var useBtn = document.getElementById('co-addr-use');
    if (useBtn) {
      useBtn.addEventListener('click', function() {
        var first = (document.getElementById('co-first') || {}).value || '';
        var last  = (document.getElementById('co-last')  || {}).value || '';
        var addr1 = (document.getElementById('co-addr1') || {}).value || '';
        var addr2 = (document.getElementById('co-addr2') || {}).value || '';
        var city  = (document.getElementById('co-city')  || {}).value || '';
        var zip   = (document.getElementById('co-zip')   || {}).value || '';
        var stateEl   = document.getElementById('co-state');
        var province  = stateEl ? stateEl.value : '';
        var countryEl = document.getElementById('co-country');
        var country   = countryEl ? countryEl.value : '';
        var countryText = countryEl ? (countryEl.options[countryEl.selectedIndex] || {}).text || '' : '';
        var name   = (first + ' ' + last).trim();
        var detail = addr1 + (addr2 ? ', ' + addr2 : '') + ' · ' + city + ', ' + zip + ' · ' + countryText;
        fillSummary(name, 'This order only', 'addr-card__badge--tag', detail);
        saveNewAddress('co');
        collapseAddr();
        refreshShipping();
      });
    }

    // "Add to my profile" — persist via worker
    var addBtn = document.getElementById('co-addr-add');
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        var workerUrl  = addBtn.dataset.workerUrl;
        var customerId = addBtn.dataset.customerId;
        var first = (document.getElementById('co-first') || {}).value || '';
        var last  = (document.getElementById('co-last')  || {}).value || '';
        var addr1 = (document.getElementById('co-addr1') || {}).value || '';
        var addr2 = (document.getElementById('co-addr2') || {}).value || '';
        var city  = (document.getElementById('co-city')  || {}).value || '';
        var zip   = (document.getElementById('co-zip')   || {}).value || '';
        var stateEl   = document.getElementById('co-state');
        var province  = stateEl ? stateEl.value : '';
        var countryEl = document.getElementById('co-country');
        var country   = countryEl ? countryEl.value : '';
        var countryText = countryEl ? (countryEl.options[countryEl.selectedIndex] || {}).text || '' : '';
        var name   = (first + ' ' + last).trim();
        var detail = addr1 + (addr2 ? ', ' + addr2 : '') + ' · ' + city + ', ' + zip + ' · ' + countryText;
        if (workerUrl && customerId) {
          addBtn.disabled = true;
          addBtn.textContent = 'Saving...';
          fetch(workerUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customerId: customerId, address: { firstName: first, lastName: last, address1: addr1, address2: addr2, city: city, province: province, country: country, zip: zip } })
          }).then(function(r) { return r.json(); }).then(function(res) {
            addBtn.disabled = false;
            addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M19 8v6"/><path d="M22 11h-6"/></svg> Add to my profile';
            if (res.error) {
              alert('Could not save: ' + res.error);
              fillSummary(name, 'This order only', 'addr-card__badge--tag', detail);
              collapseAddr();
              refreshShipping();
              return;
            }
            fillSummary(name, 'Saved', '', detail);
            collapseAddr();
            refreshShipping();
          }).catch(function() {
            addBtn.disabled = false;
            addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M19 8v6"/><path d="M22 11h-6"/></svg> Add to my profile';
            fillSummary(name, 'This order only', 'addr-card__badge--tag', detail);
            collapseAddr();
            refreshShipping();
          });
        } else {
          fillSummary(name, 'This order only', 'addr-card__badge--tag', detail);
          collapseAddr();
          refreshShipping();
        }
      });
    }

    // Auto-init: populate form fields and fetch rates for the pre-selected address.
    // Restores from sessionStorage first (survives qty-change reload); falls back to default.
    // Only runs on desktop — mobile IIFE handles its own auto-init.
    setTimeout(function() {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      var saved = getSavedAddress();
      if (saved && saved.isNew) {
        // Restore a previously typed new address
        function set(id, v) { var el = document.getElementById(id); if (el) el.value = v || ''; }
        set('co-first',  saved.first);
        set('co-last',   saved.last);
        set('co-addr1',  saved.addr1);
        set('co-addr2',  saved.addr2);
        set('co-city',   saved.city);
        set('co-zip',    saved.zip);
        var countryEl = document.getElementById('co-country');
        var stateEl   = document.getElementById('co-state');
        if (countryEl && saved.country) {
          countryEl.value = saved.country;
          // Rebuild provinces for the restored country
          var selOpt = countryEl.options[countryEl.selectedIndex];
          var provinces = [];
          try { provinces = JSON.parse(selOpt && selOpt.dataset.provinces || '[]'); } catch(e) {}
          if (stateEl) {
            stateEl.innerHTML = '';
            var wrap = stateEl.closest('.fld');
            if (provinces.length === 0) {
              if (wrap) wrap.style.display = 'none';
            } else {
              if (wrap) wrap.style.display = '';
              provinces.forEach(function(p) {
                var opt = document.createElement('option');
                opt.value = p[0]; opt.textContent = p[1];
                stateEl.appendChild(opt);
              });
              if (saved.province) {
                stateEl.value = saved.province;
                if (stateEl.value !== saved.province) {
                  var m = Array.from(stateEl.options).find(function(o) { return o.textContent.trim() === saved.province; });
                  if (m) stateEl.value = m.value;
                }
              }
            }
          }
        }
        var countryText = countryEl ? (countryEl.options[countryEl.selectedIndex] || {}).text || '' : '';
        fillSummary(
          (saved.first + ' ' + saved.last).trim(),
          'This order only', 'addr-card__badge--tag',
          saved.addr1 + (saved.addr2 ? ', ' + saved.addr2 : '') + ' · ' + saved.city + ', ' + saved.zip + ' · ' + countryText
        );
        refreshShipping();
      } else if (saved && !saved.isNew && saved.cardId && addrList) {
        // Restore a saved address card selection
        var radio = addrList.querySelector('input[value="' + saved.cardId + '"]');
        var card  = radio && radio.closest('.addr-card');
        if (card) {
          radio.checked = true;
          addrList.querySelectorAll('.addr-card').forEach(function(c) { c.classList.remove('addr-card--on'); });
          card.classList.add('addr-card--on');
          syncFormFromCard(card);
          var name   = (card.dataset.first || '') + ' ' + (card.dataset.last || '');
          var detail = card.dataset.addr1 +
            (card.dataset.addr2 ? ', ' + card.dataset.addr2 : '') +
            ' · ' + card.dataset.city + ', ' + (card.dataset.province ? card.dataset.province + ' ' : '') + card.dataset.zip + ' · ' + card.dataset.country;
          var badgeEl = card.querySelector('.addr-card__badge');
          var badge   = badgeEl ? badgeEl.textContent : '';
          var badgeClass = badgeEl ? (badgeEl.classList.contains('addr-card__badge--tag') ? 'addr-card__badge--tag' : '') : '';
          fillSummary(name.trim(), badge, badgeClass, detail);
          refreshShipping();
        } else {
          // Card no longer exists — clear stale key and fall back to default
          clearSavedAddress();
          var initRadio = addrList.querySelector('input[type="radio"]:checked');
          var initCard  = initRadio && initRadio.value !== 'new' && initRadio.closest('.addr-card');
          if (initCard) { syncFormFromCard(initCard); refreshShipping(); }
        }
      } else {
        // Default: use the pre-checked address card (customer default)
        var initRadio = addrList && addrList.querySelector('input[type="radio"]:checked');
        var initCard  = initRadio && initRadio.value !== 'new' && initRadio.closest('.addr-card');
        if (initCard) {
          syncFormFromCard(initCard);
          refreshShipping();
        }
      }
    }, 0);
  })();

  // ── Multi-address picker — mobile ──────────────────────────────────────────
  (function() {
    var collapsed  = document.getElementById('mco-addr-collapsed');
    var expanded   = document.getElementById('mco-addr-expanded');
    var expandBtn  = document.getElementById('mco-addr-expand');
    var addrForm   = document.getElementById('mco-addr-form');
    var addrList   = expanded && expanded.querySelector('.mco-addr-list');
    if (!collapsed || !expanded || !expandBtn) return;

    function collapseAddr() {
      expanded.hidden  = true;
      collapsed.hidden = false;
    }
    function expandAddr() {
      expanded.hidden  = false;
      collapsed.hidden = true;
    }
    expandBtn.addEventListener('click', expandAddr);

    function syncFormFromCard(card) {
      var d = card.dataset;
      var set = function(id, val) { var el = document.getElementById(id); if (el) el.value = val || ''; };
      set('mco-first',  d.first);
      set('mco-last',   d.last);
      set('mco-addr1',  d.addr1);
      set('mco-addr2',  d.addr2);
      set('mco-city',   d.city);
      set('mco-zip',    d.zip);

      var countryEl = document.getElementById('mco-country');
      var stateEl   = document.getElementById('mco-state');

      if (countryEl && d.country) {
        var countryOpt = Array.from(countryEl.options).find(function(o) {
          return o.value === d.country || o.textContent.trim() === d.country;
        });
        if (countryOpt) countryEl.value = countryOpt.value;
      }

      if (stateEl && countryEl) {
        var selOpt = countryEl.options[countryEl.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(selOpt && selOpt.dataset.provinces || '[]'); } catch (e) {}
        stateEl.innerHTML = '';
        var wrap = stateEl.closest('.mco-fld');
        if (provinces.length === 0) {
          if (wrap) wrap.style.display = 'none';
        } else {
          if (wrap) wrap.style.display = '';
          provinces.forEach(function(p) {
            var opt = document.createElement('option');
            opt.value = p[0];
            opt.textContent = p[1];
            stateEl.appendChild(opt);
          });
          if (d.province) {
            stateEl.value = d.province;
            if (stateEl.value !== d.province) {
              var m = Array.from(stateEl.options).find(function(o) { return o.textContent.trim() === d.province; });
              if (m) stateEl.value = m.value;
            }
          }
        }
      }

      if (window.AigoShipping && window.AigoShipping.cancelPendingFetch) {
        window.AigoShipping.cancelPendingFetch();
      }
    }

    function fillSummary(name, badge, badgeClass, detail) {
      var nameEl   = document.getElementById('mco-addr-name');
      var badgeEl  = document.getElementById('mco-addr-badge');
      var detailEl = document.getElementById('mco-addr-detail');
      if (nameEl)   nameEl.textContent   = name;
      if (detailEl) detailEl.textContent = detail;
      if (badgeEl) {
        badgeEl.textContent  = badge || '';
        badgeEl.className    = badge ? ('mco-addr-card__badge' + (badgeClass ? ' ' + badgeClass : '')) : '';
        badgeEl.style.display = badge ? '' : 'none';
      }
    }

    if (addrList) {
      var reselecting = false;
      addrList.addEventListener('mousedown', function(e) {
        var card = e.target.closest('.mco-addr-card');
        if (!card) return;
        var radio = card.querySelector('input[type="radio"]');
        reselecting = !!(radio && radio.checked && radio.value !== 'new');
      });
      addrList.addEventListener('click', function(e) {
        if (reselecting) {
          reselecting = false;
          var card = e.target.closest('.mco-addr-card');
          collapseAddr();
          if (card) refreshShipping();
        }
      });
      addrList.addEventListener('change', function(e) {
        var radio = e.target;
        if (radio.type !== 'radio') return;
        addrList.querySelectorAll('.mco-addr-card').forEach(function(c) { c.classList.remove('mco-addr-card--on'); });
        var card = radio.closest('.mco-addr-card');
        if (card) card.classList.add('mco-addr-card--on');

        if (radio.value === 'new') {
          if (addrForm) addrForm.hidden = false;
        } else {
          if (addrForm) addrForm.hidden = true;
          if (card) {
            syncFormFromCard(card);
            saveCardAddress(radio.value);
            var name   = (card.dataset.first || '') + ' ' + (card.dataset.last || '');
            var detail = card.dataset.addr1 +
              (card.dataset.addr2 ? ', ' + card.dataset.addr2 : '') +
              ' · ' + card.dataset.city + ', ' + (card.dataset.province ? card.dataset.province + ' ' : '') + card.dataset.zip + ' · ' + card.dataset.country;
            var badgeEl   = card.querySelector('.mco-addr-card__badge');
            var badge     = badgeEl ? badgeEl.textContent : '';
            var badgeClass = badgeEl ? (badgeEl.classList.contains('mco-addr-card__badge--tag') ? 'mco-addr-card__badge--tag' : '') : '';
            fillSummary(name.trim(), badge, badgeClass, detail);
            collapseAddr();
            refreshShipping();
          }
        }
      });
    }

    var useBtn = document.getElementById('mco-addr-use');
    if (useBtn) {
      useBtn.addEventListener('click', function() {
        var first = (document.getElementById('mco-first') || {}).value || '';
        var last  = (document.getElementById('mco-last')  || {}).value || '';
        var addr1 = (document.getElementById('mco-addr1') || {}).value || '';
        var addr2 = (document.getElementById('mco-addr2') || {}).value || '';
        var city  = (document.getElementById('mco-city')  || {}).value || '';
        var zip   = (document.getElementById('mco-zip')   || {}).value || '';
        var stateEl   = document.getElementById('mco-state');
        var province  = stateEl ? stateEl.value : '';
        var countryEl = document.getElementById('mco-country');
        var country = countryEl ? (countryEl.options[countryEl.selectedIndex] || {}).text || '' : '';
        fillSummary(
          (first + ' ' + last).trim(),
          'This order only', 'mco-addr-card__badge--tag',
          addr1 + (addr2 ? ', ' + addr2 : '') + ' · ' + city + ', ' + zip + ' · ' + country
        );
        saveNewAddress('mco');
        collapseAddr();
        refreshShipping();
      });
    }

    var addBtn = document.getElementById('mco-addr-add');
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        var workerUrl  = addBtn.dataset.workerUrl;
        var customerId = addBtn.dataset.customerId;
        var first = (document.getElementById('mco-first') || {}).value || '';
        var last  = (document.getElementById('mco-last')  || {}).value || '';
        var addr1 = (document.getElementById('mco-addr1') || {}).value || '';
        var addr2 = (document.getElementById('mco-addr2') || {}).value || '';
        var city  = (document.getElementById('mco-city')  || {}).value || '';
        var zip   = (document.getElementById('mco-zip')   || {}).value || '';
        var stateEl   = document.getElementById('mco-state');
        var province  = stateEl ? stateEl.value : '';
        var countryEl = document.getElementById('mco-country');
        var country   = countryEl ? countryEl.value : '';
        var countryText = countryEl ? (countryEl.options[countryEl.selectedIndex] || {}).text || '' : '';
        var name   = (first + ' ' + last).trim();
        var detail = addr1 + (addr2 ? ', ' + addr2 : '') + ' · ' + city + ', ' + zip + ' · ' + countryText;
        if (workerUrl && customerId) {
          addBtn.disabled = true;
          addBtn.textContent = 'Saving...';
          fetch(workerUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customerId: customerId, address: { firstName: first, lastName: last, address1: addr1, address2: addr2, city: city, province: province, country: country, zip: zip } })
          }).then(function(r) { return r.json(); }).then(function(res) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to my profile';
            if (res.error) {
              alert('Could not save: ' + res.error);
              fillSummary(name, 'This order only', 'mco-addr-card__badge--tag', detail);
              collapseAddr();
              refreshShipping();
              return;
            }
            fillSummary(name, 'Saved', '', detail);
            collapseAddr();
            refreshShipping();
          }).catch(function() {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to my profile';
            fillSummary(name, 'This order only', 'mco-addr-card__badge--tag', detail);
            collapseAddr();
            refreshShipping();
          });
        } else {
          fillSummary(name, 'This order only', 'mco-addr-card__badge--tag', detail);
          collapseAddr();
          refreshShipping();
        }
      });
    }

    // Auto-init: populate form fields and fetch rates for the pre-selected address.
    // Restores from sessionStorage first (survives qty-change reload); falls back to default.
    // Only runs on mobile — desktop IIFE handles its own auto-init.
    setTimeout(function() {
      if (!window.matchMedia('(max-width: 900px)').matches) return;
      var saved = getSavedAddress();
      if (saved && saved.isNew) {
        // Restore a previously typed new address
        function set(id, v) { var el = document.getElementById(id); if (el) el.value = v || ''; }
        set('mco-first',  saved.first);
        set('mco-last',   saved.last);
        set('mco-addr1',  saved.addr1);
        set('mco-addr2',  saved.addr2);
        set('mco-city',   saved.city);
        set('mco-zip',    saved.zip);
        var countryEl = document.getElementById('mco-country');
        var stateEl   = document.getElementById('mco-state');
        if (countryEl && saved.country) {
          countryEl.value = saved.country;
          var selOpt = countryEl.options[countryEl.selectedIndex];
          var provinces = [];
          try { provinces = JSON.parse(selOpt && selOpt.dataset.provinces || '[]'); } catch(e) {}
          if (stateEl) {
            stateEl.innerHTML = '';
            var wrap = stateEl.closest('.mco-fld');
            if (provinces.length === 0) {
              if (wrap) wrap.style.display = 'none';
            } else {
              if (wrap) wrap.style.display = '';
              provinces.forEach(function(p) {
                var opt = document.createElement('option');
                opt.value = p[0]; opt.textContent = p[1];
                stateEl.appendChild(opt);
              });
              if (saved.province) {
                stateEl.value = saved.province;
                if (stateEl.value !== saved.province) {
                  var m = Array.from(stateEl.options).find(function(o) { return o.textContent.trim() === saved.province; });
                  if (m) stateEl.value = m.value;
                }
              }
            }
          }
        }
        var countryText = countryEl ? (countryEl.options[countryEl.selectedIndex] || {}).text || '' : '';
        fillSummary(
          (saved.first + ' ' + saved.last).trim(),
          'This order only', 'mco-addr-card__badge--tag',
          saved.addr1 + (saved.addr2 ? ', ' + saved.addr2 : '') + ' · ' + saved.city + ', ' + saved.zip + ' · ' + countryText
        );
        refreshShipping();
      } else if (saved && !saved.isNew && saved.cardId && addrList) {
        // Restore a saved address card selection
        var radio = addrList.querySelector('input[value="' + saved.cardId + '"]');
        var card  = radio && radio.closest('.mco-addr-card');
        if (card) {
          radio.checked = true;
          addrList.querySelectorAll('.mco-addr-card').forEach(function(c) { c.classList.remove('mco-addr-card--on'); });
          card.classList.add('mco-addr-card--on');
          syncFormFromCard(card);
          var name   = (card.dataset.first || '') + ' ' + (card.dataset.last || '');
          var detail = card.dataset.addr1 +
            (card.dataset.addr2 ? ', ' + card.dataset.addr2 : '') +
            ' · ' + card.dataset.city + ', ' + (card.dataset.province ? card.dataset.province + ' ' : '') + card.dataset.zip + ' · ' + card.dataset.country;
          var badgeEl   = card.querySelector('.mco-addr-card__badge');
          var badge     = badgeEl ? badgeEl.textContent : '';
          var badgeClass = badgeEl ? (badgeEl.classList.contains('mco-addr-card__badge--tag') ? 'mco-addr-card__badge--tag' : '') : '';
          fillSummary(name.trim(), badge, badgeClass, detail);
          refreshShipping();
        } else {
          // Card no longer exists — clear stale key and fall back to default
          clearSavedAddress();
          var initRadio = addrList.querySelector('input[type="radio"]:checked');
          var initCard  = initRadio && initRadio.value !== 'new' && initRadio.closest('.mco-addr-card');
          if (initCard) { syncFormFromCard(initCard); refreshShipping(); }
        }
      } else {
        // Default: use the pre-checked address card (customer default)
        var initRadio = addrList && addrList.querySelector('input[type="radio"]:checked');
        var initCard  = initRadio && initRadio.value !== 'new' && initRadio.closest('.mco-addr-card');
        if (initCard) {
          syncFormFromCard(initCard);
          refreshShipping();
        }
      }
    }, 0);
  })();

  // ── Promo code apply (desktop + mobile) ──────────────────────────────
  (function() {
    var promoCents = 0;
    var busy = false;

    // On page load, clear any discount code that may have been left in the
    // Shopify cart session from a previous order or page reload. The code
    // should never persist — we track it in window._aigoPromoCents only.
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      if (c.discount_codes && c.discount_codes.length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
      }
    });

    function fmtMoney(cents) {
      var sym = (window.Shopify && window.Shopify.currency && window.Shopify.currency.symbol) || '$';
      return sym + (cents / 100).toFixed(2);
    }

    function applyPromo(code, inputEl, rowEl, valEl, errEl) {
      if (busy || !code) return;
      busy = true;
      var btn = inputEl.nextElementSibling;
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Checking...'; btn.disabled = true; }
      if (errEl) errEl.textContent = '';

      var fd = new FormData();
      fd.append('discount', code);

      fetch('/cart/update.js', { method: 'POST', body: fd })
        .then(function(r) { return r.json(); })
        .then(function(state) {
          // Check if code was rejected
          var rejected = state.discount_codes && state.discount_codes.find(function(d) {
            return d.code.toUpperCase() === code.toUpperCase() && d.applicable === false;
          });
          if (rejected) {
            if (errEl) errEl.textContent = 'Invalid or inapplicable promo code.';
            busy = false;
            if (btn) { btn.textContent = origText; btn.disabled = false; }
            return;
          }
          // Fetch cart to get discount amount
          return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            // Verify the code is actually in the cart as applicable
            var applied = cart.discount_codes && cart.discount_codes.find(function(d) {
              return d.code.toUpperCase() === code.toUpperCase() && d.applicable === true;
            });
            if (!applied) {
              if (errEl) errEl.textContent = 'Invalid or inapplicable promo code.';
              busy = false;
              if (btn) { btn.textContent = origText; btn.disabled = false; }
              return;
            }
            console.log('[Promo] discount_codes from /cart.js:', JSON.stringify(cart.discount_codes));
            console.log('[Promo] applied entry:', JSON.stringify(applied));
            console.log('[Promo] cart.total_discount (cents):', cart.total_discount);
            // cart.discount_codes[].amount is unpopulated in this store's API response;
            // use cart.total_discount instead (integer cents, reliable source of truth).
            promoCents = cart.total_discount || 0;
            console.log('[Promo] promoCents computed:', promoCents);
            // Immediately remove the code from the Shopify cart session.
            // cart.total_price (and est_subtotal_cents in Liquid) must not be
            // permanently reduced by a cart-level code — we track the discount
            // in window._aigoPromoCents only, so it stays JS-only and doesn't
            // bleed into future page loads or subsequent orders.
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: '' })
            }).then(function() {
              window._aigoPromoCents = promoCents;
              if (window.FoxTheme && window.FoxTheme.Cart) window.FoxTheme.Cart.setPromoDiscount(promoCents);
              if (rowEl) rowEl.style.display = 'flex';
              if (valEl) valEl.textContent = '\u2212' + fmtMoney(promoCents);
              // Update totals
              updatePromoTotals();
              busy = false;
              if (btn) { btn.textContent = origText; btn.disabled = false; }
            });
          }); // closes .then(function(cart) {...})
        }) // closes .then(function(state) {...})
        .catch(function() {
          if (errEl) errEl.textContent = 'Could not apply code. Please try again.';
          busy = false;
          if (btn) { btn.textContent = origText; btn.disabled = false; }
        });
    }

    function updatePromoTotals() {
      // Always compute from the source-of-truth baseline, not from DOM text.
      var card = document.getElementById('aigo-ship-card');
      if (!card) return;
      var estSubtotal = parseInt(card.dataset.estSubtotalCents || '0', 10);
      // Trigger aigo-shipping.js to recompute totals (it already reads window._aigoPromoCents)
      if (window.AigoShipping && window.AigoShipping.refreshRates) {
        window.AigoShipping.refreshRates();
      } else {
        // Fallback: update totals directly from baseline
        var sym = (window.Shopify && window.Shopify.currency && window.Shopify.currency.symbol) || '$';
        var netCents = Math.max(0, estSubtotal - promoCents);
        var deskTotal = document.getElementById('sum-total-val');
        var mobTotal  = document.getElementById('mco-total-val');
        if (deskTotal) deskTotal.textContent = '~' + sym + (netCents / 100).toFixed(2);
        if (mobTotal)  mobTotal.textContent  = '~' + sym + (netCents / 100).toFixed(2);
      }
    }

    // Desktop
    var dApplyBtn = document.getElementById('co-apply');
    var dPromoIn  = document.getElementById('co-promo');
    var dPromoRow = document.getElementById('co-promo-row');
    var dPromoVal = document.getElementById('co-promo-val');
    var dErrEl    = document.getElementById('co-promo-err');
    if (dApplyBtn && dPromoIn) {
      dApplyBtn.addEventListener('click', function() {
        applyPromo(dPromoIn.value.trim(), dPromoIn, dPromoRow, dPromoVal, dErrEl);
      });
    }

    // Mobile
    var mApplyBtn = document.getElementById('mco-apply');
    var mPromoIn  = document.getElementById('mco-promo');
    var mPromoRow = document.getElementById('mco-promo-row');
    var mPromoVal = document.getElementById('mco-promo-val');
    var mErrEl    = document.getElementById('mco-promo-err');
    if (mApplyBtn && mPromoIn) {
      mApplyBtn.addEventListener('click', function() {
        applyPromo(mPromoIn.value.trim(), mPromoIn, mPromoRow, mPromoVal, mErrEl);
      });
    }

    function removePromo() {
      window._aigoPromoCents = 0;
      if (window.FoxTheme && window.FoxTheme.Cart) window.FoxTheme.Cart.setPromoDiscount(0);
      promoCents = 0;
      if (dPromoRow) dPromoRow.style.display = 'none';
      if (mPromoRow) mPromoRow.style.display = 'none';
      if (dPromoIn)  dPromoIn.value  = '';
      if (mPromoIn)  mPromoIn.value  = '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).finally(function() {
        if (window.AigoShipping && window.AigoShipping.refreshRates) {
          window.AigoShipping.refreshRates();
        }
      });
    }
    var dRemoveBtn = document.getElementById('co-promo-remove');
    var mRemoveBtn = document.getElementById('mco-promo-remove');
    if (dRemoveBtn) dRemoveBtn.addEventListener('click', removePromo);
    if (mRemoveBtn) mRemoveBtn.addEventListener('click', removePromo);
  })();
})();

// ── Minimum-order modal / sheet ───────────────────────────────────────────
(function() {
  // Desktop modal
  var placeBtn   = document.getElementById('place-order');
  var scrim      = document.getElementById('co-min-scrim');
  var closeBtn   = document.getElementById('co-min-close');
  var continueBtn = document.getElementById('co-min-continue');

  // Mobile sheet
  var placeBtnM   = document.getElementById('mco-place-order');
  var scrimM      = document.getElementById('mco-min-scrim');
  var sheetM      = document.getElementById('mco-min-sheet');
  var closeBtnM   = document.getElementById('mco-min-close');
  var continueBtnM = document.getElementById('mco-min-continue');

  function openModal()  { if (scrim)  scrim.classList.add('show'); }
  function closeModal() { if (scrim)  scrim.classList.remove('show'); }
  function openSheet()  { if (sheetM) { sheetM.classList.add('open');  if (scrimM) scrimM.classList.add('show'); } }
  function closeSheet() { if (sheetM) { sheetM.classList.remove('open'); if (scrimM) scrimM.classList.remove('show'); } }

  if (placeBtn && placeBtn.classList.contains('btn--locked')) {
    placeBtn.addEventListener('click', openModal);
  }
  if (closeBtn)       closeBtn.addEventListener('click', closeModal);
  if (continueBtn)    continueBtn.addEventListener('click', closeModal);
  if (scrim)          scrim.addEventListener('click', function(e) { if (e.target === scrim) closeModal(); });

  if (placeBtnM && placeBtnM.classList.contains('m-btn--locked')) {
    placeBtnM.addEventListener('click', openSheet);
  }
  if (closeBtnM)    closeBtnM.addEventListener('click', closeSheet);
  if (continueBtnM) continueBtnM.addEventListener('click', closeSheet);
  if (scrimM)    scrimM.addEventListener('click', closeSheet);

  if (scrim || scrimM) {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeModal(); closeSheet(); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-main-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Mobile filter sheet open/close
  var openBtn  = document.getElementById('AigoOpenFilterSheet');
  var sheet    = document.getElementById('AigoFilterSheet');
  var closeBtn = document.getElementById('AigoCloseFilterSheet');
  var scrim    = document.getElementById('AigoFilterScrim');
  var applyBtn = document.getElementById('AigoApplyFilters');

  if (!openBtn || !sheet || !scrim) return;

  function openSheet() {
    sheet.classList.add('open');
    scrim.classList.add('show');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    sheet.classList.remove('open');
    scrim.classList.remove('show');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openSheet);
  closeBtn.addEventListener('click', closeSheet);
  scrim.addEventListener('click', closeSheet);
  if (applyBtn) applyBtn.addEventListener('click', closeSheet);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-main-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var pdp = document.querySelector('.pdp');
  var showPrices      = pdp && pdp.dataset.showPrices      === 'true';
  var showAtcPrice    = pdp && pdp.dataset.showAtcPrice    === 'true';
  var showSatcCompare = pdp && pdp.dataset.showSatcCompare === 'true';

  // ── Qty stepper references (declared early; used in updateUI and change listeners) ──
  var mainQtyInput = document.querySelector('quantity-input:not(.qtystep--satc) input[type="number"]');
  var satcQtyInput = document.querySelector('.qtystep--satc input[type="number"]');

  // ── Gallery ──
  var thumbs  = document.querySelectorAll('.thumb');
  var mainImg = document.getElementById('aigo-main-img');
  var mediaUrls = JSON.parse(document.getElementById('aigo-media-json').textContent);

  thumbs.forEach(function(btn) {
    btn.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('on'); });
      btn.classList.add('on');
      if (btn.dataset.proxyId && mainImg) {
        var base = window.FoxTheme && window.FoxTheme.proxyBase;
        if (base) mainImg.src = base + '?id=' + btn.dataset.proxyId;
      } else {
        var idx = parseInt(btn.dataset.mediaIndex, 10);
        if (mediaUrls[idx] && mainImg) mainImg.src = mediaUrls[idx];
      }
    });
  });

  // ── Variant picker ──
  var variantsData    = JSON.parse(document.getElementById('aigo-variants-json').textContent);
  var currentId       = parseInt(document.getElementById('aigo-variant-id').value, 10);
  var current         = variantsData.find(function(v) { return v.id === currentId; });
  var selectedOptions = current ? current.options.slice() : (variantsData[0] ? variantsData[0].options.slice() : []);

  function findVariant(opts) {
    return variantsData.find(function(v) {
      return v.options.every(function(o, i) { return o === opts[i]; });
    });
  }

  function formatMoney(cents) {
    var fmtEl = document.getElementById('aigo-money-format');
    var fmt   = fmtEl ? fmtEl.textContent.trim() : '';
    var amount    = (cents / 100).toFixed(2);
    var amountInt = String(Math.round(cents / 100));
    if (!fmt) return '$' + amount;
    return fmt
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, amountInt.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount.replace('.', ','))
      .replace(/\{\{amount_no_decimals\}\}/g, amountInt)
      .replace(/\{\{amount\}\}/g, amount);
  }

  // Pre-compute: cheapest available price per option-index→value
  function buildSubLabels() {
    if (!showPrices) return;
    // For each option index, build map: value → lowest price among available variants
    var optionCount = variantsData[0] ? variantsData[0].options.length : 0;
    var maps = [];
    for (var i = 0; i < optionCount; i++) {
      var map = {};
      variantsData.forEach(function(v) {
        var val = v.options[i];
        if (v.available) {
          if (map[val] === undefined || v.price < map[val]) map[val] = v.price;
        }
      });
      maps.push(map);
    }
    document.querySelectorAll('.vopt').forEach(function(btn) {
      var optIdx = parseInt(btn.dataset.optionIndex, 10);
      var val    = btn.dataset.value;
      var sub    = btn.querySelector('.vopt__sub');
      if (!sub) return;
      var map = maps[optIdx];
      if (map && map[val] !== undefined) {
        sub.textContent = formatMoney(map[val]);
      } else {
        sub.textContent = '';
      }
    });
  }

  // Sold-out class sync on variant change
  function updateSoldoutClasses(newSelectedOptions) {
    var showSoldout = pdp && pdp.dataset.showSoldoutStyling === 'true';
    if (!showSoldout) return;
    var optionCount = newSelectedOptions.length;
    for (var i = 0; i < optionCount; i++) {
      document.querySelectorAll('.vopt[data-option-index="' + i + '"]').forEach(function(btn) {
        var val = btn.dataset.value;
        // Check if ANY variant with this value is available
        var anyAvailable = variantsData.some(function(v) {
          return v.options[i] === val && v.available;
        });
        btn.classList.toggle('soldout', !anyAvailable);
        btn.disabled = !anyAvailable;
      });
    }
  }

  function updateUI(variant) {
    var priceEl     = document.getElementById('aigo-price');
    var compareEl   = document.getElementById('aigo-compare');
    var saveBadgeEl = document.getElementById('aigo-save-badge');
    var skuEl       = document.getElementById('aigo-sku');
    var stockEl     = document.getElementById('aigo-stock-status');
    var satcPrice   = document.getElementById('aigo-satc-price');
    var satcCompare = document.getElementById('aigo-satc-compare');
    var variantIn   = document.getElementById('aigo-variant-id');
    var atcBtns     = document.querySelectorAll('.btn--atc');

    if (!variant) {
      // priceEl is null when show_prices=false (element not rendered by Liquid), so this is always a no-op in that mode
      if (priceEl) priceEl.textContent = 'Unavailable';
      atcBtns.forEach(function(b) { b.disabled = true; b.textContent = 'Unavailable'; });
      return;
    }

    if (variantIn) variantIn.value = variant.id;
    if (skuEl && variant.sku) skuEl.textContent = variant.sku;

    // Stock status
    if (stockEl) {
      stockEl.textContent = variant.available ? 'In stock' : 'Out of stock';
      stockEl.style.cssText = variant.available ? 'color:var(--green-700);font-weight:600' : 'color:var(--tomato-500)';
    }

    if (showPrices) {
      if (priceEl)   priceEl.textContent = formatMoney(variant.price);
      if (satcPrice) satcPrice.textContent = formatMoney(variant.price);

      // Compare-at / save badge
      var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.textContent = isOnSale ? formatMoney(variant.compare_at_price) : '';
        compareEl.hidden = !isOnSale;
      }
      if (saveBadgeEl) {
        if (isOnSale) {
          var saveAmt = variant.compare_at_price - variant.price;
          saveBadgeEl.textContent = 'Save ' + formatMoney(saveAmt);
          saveBadgeEl.hidden = false;
        } else {
          saveBadgeEl.hidden = true;
        }
      }

      // Gallery sale badge
      var galleryBadge = document.querySelector('.gmain__badge');
      if (galleryBadge) {
        if (isOnSale) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          galleryBadge.textContent = 'Save ' + pct + '%';
          galleryBadge.hidden = false;
        } else {
          galleryBadge.hidden = true;
        }
      }

      // Sticky bar compare-at
      if (satcCompare) {
        if (showSatcCompare && isOnSale) {
          satcCompare.textContent = formatMoney(variant.compare_at_price);
          satcCompare.hidden = false;
        } else {
          satcCompare.hidden = true;
        }
      }
    }

    // ATC buttons
    atcBtns.forEach(function(b) {
      b.disabled = !variant.available;
      b.setAttribute('aria-disabled', String(!variant.available));
      if (!variant.available) {
        b.textContent = 'Sold Out';
      } else if (showAtcPrice && showPrices) {
        b.textContent = 'Add to Cart · ' + formatMoney(variant.price);
      } else {
        b.textContent = 'Add to Cart';
      }
    });

    var buyNow = document.getElementById('aigo-buynow');
    var qtyVal = mainQtyInput ? parseInt(mainQtyInput.value, 10) || 1 : 1;
    if (buyNow) buyNow.href = '/cart?variant=' + variant.id + '&quantity=' + qtyVal;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
  }

  document.querySelectorAll('.vopt').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.classList.contains('soldout') || btn.disabled) return;
      var optIdx = parseInt(btn.dataset.optionIndex, 10);
      selectedOptions[optIdx] = btn.dataset.value;

      document.querySelectorAll('.vopt[data-option-index="' + optIdx + '"]').forEach(function(b) {
        b.classList.toggle('on', b.dataset.value === btn.dataset.value);
      });

      var lbl = document.getElementById('aigo-opt-val-' + optIdx);
      if (lbl) lbl.textContent = btn.dataset.value;

      updateUI(findVariant(selectedOptions));
      updateSoldoutClasses(selectedOptions);
    });
  });

  // Build sub-labels after formatMoney is ready
  buildSubLabels();

  // ── Accordion ──
  document.querySelectorAll('.pacc__h').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.pacc__item');
      var isOpen = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });

  // ── Linked quantity steppers ──
  if (mainQtyInput && satcQtyInput) {
    mainQtyInput.addEventListener('change', function() { satcQtyInput.value = mainQtyInput.value; });
    satcQtyInput.addEventListener('change', function() { mainQtyInput.value = satcQtyInput.value; });
  }

  // Update Buy Now href when qty stepper changes
  function updateBuyNowQty() {
    var buyNow = document.getElementById('aigo-buynow');
    if (!buyNow) return;
    var qtyVal = mainQtyInput ? parseInt(mainQtyInput.value, 10) || 1 : 1;
    buyNow.href = buyNow.href.replace(/&quantity=\d+/, '&quantity=' + qtyVal);
  }
  if (mainQtyInput) mainQtyInput.addEventListener('change', updateBuyNowQty);

  // Share copy link
  document.querySelectorAll('.share__copy').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      navigator.clipboard && navigator.clipboard.writeText(el.dataset.url || window.location.href);
    });
  });

  // ── Sticky ATC bar ──
  var satc   = document.getElementById('aigo-satc');
  var buyrow = document.querySelector('.buyrow');
  if (satc && buyrow && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      satc.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(buyrow);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-store-locator"] && !Shopify.designMode) return;
  try {
    
  // Mobile: sync pin ↔ card selection
  document.querySelectorAll('.msl-pin').forEach(function(p) {
    p.addEventListener('click', function() {
      var id = p.dataset.id;
      document.querySelectorAll('.msl-pin').forEach(function(x) { x.classList.toggle('on', x.dataset.id === id); });
      document.querySelectorAll('.msl-list .slcard').forEach(function(c) { c.classList.toggle('on', c.dataset.id === id); });
    });
  });
  document.querySelectorAll('.msl-list .slcard').forEach(function(c) {
    c.addEventListener('click', function() {
      var id = c.dataset.id;
      document.querySelectorAll('.msl-list .slcard').forEach(function(x) { x.classList.toggle('on', x.dataset.id === id); });
      document.querySelectorAll('.msl-pin').forEach(function(p) { p.classList.toggle('on', p.dataset.id === id); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aigo-wishlist"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ── Wishlist key used to persist to localStorage ── */
  var WL_KEY = 'aigo_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch(e) { return []; }
  }
  function saveWishlist(items) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(items)); } catch(e) {}
  }

  var root = document.getElementById('aigo-wishlist');
  if (!root) return;

  var filledEl = root.querySelector('.mwl-filled');
  var emptyEl  = document.getElementById('wl-empty');
  var recoEl   = document.getElementById('wl-reco');
  var gridEl   = document.getElementById('wl-grid');

  function stockClass(available) {
    return available ? 'in' : 'out';
  }
  function stockIcon(cls) {
    if (cls === 'in')  return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    if (cls === 'low') return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>';
    return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/></svg>';
  }
  function stockLabel(cls) {
    if (cls === 'in')  return 'In stock';
    if (cls === 'low') return 'Low stock';
    return 'Out of stock';
  }

  function renderCard(item) {
    var s = item.available ? 'in' : 'out';
    var out = !item.available;
    var flag = item.flag ? '<span class="mwl-card__flag flag--' + item.flag.c + '">' + item.flag.t + '</span>' : '';
    var was  = item.compare_at_price && item.compare_at_price > item.price
      ? '<span class="mwl-card__was">$' + (item.compare_at_price / 100).toFixed(2) + '</span>' : '';
    var thumb = item.image
      ? '<img src="' + item.image + '" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover" loading="lazy">'
      : '<svg class="big" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
    var bg = item.image ? '' : 'style="background:linear-gradient(135deg,var(--green-700),var(--green-900))"';
    var atcBtn = out
      ? '<button class="mwl-card__atc mwl-card__atc--notify" disabled><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg> Notify me</button>'
      : '<button class="mwl-card__atc mwl-card__atc--add" data-variant="' + item.variant_id + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg> Add to cart</button>';
    return '<div class="mwl-card" data-id="' + item.id + '" data-available="' + (item.available ? '1' : '0') + '" data-sale="' + (was ? '1' : '0') + '">' +
      '<div class="mwl-card__thumb" ' + bg + '>' + thumb + flag +
        '<button class="mwl-card__rm" aria-label="Remove from wishlist" data-remove="' + item.id + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="mwl-card__body">' +
        '<span class="mwl-card__stock stock--' + s + '">' + stockIcon(s) + stockLabel(s) + '</span>' +
        '<div class="mwl-card__name">' + item.title + '</div>' +
        '<div class="mwl-card__price">$' + (item.price / 100).toFixed(2) + was + '</div>' +
        atcBtn +
      '</div>' +
    '</div>';
  }

  function render() {
    var items = getWishlist();
    if (items.length === 0) {
      filledEl.style.display = 'none';
      emptyEl.style.display  = '';
      if (recoEl) recoEl.style.display = '';
      return;
    }
    filledEl.style.display = '';
    emptyEl.style.display  = 'none';
    if (recoEl) recoEl.style.display = 'none';
    gridEl.innerHTML = items.map(renderCard).join('');
    /* remove buttons */
    gridEl.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = btn.getAttribute('data-remove');
        saveWishlist(getWishlist().filter(function(i) { return String(i.id) !== id; }));
        render();
        document.dispatchEvent(new CustomEvent('aigo:wishlist:updated'));
      });
    });
    /* ATC buttons */
    gridEl.querySelectorAll('.mwl-card__atc--add').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.getAttribute('data-variant');
        if (!variantId) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function() {
          document.dispatchEvent(new Event('foxtheme:cart:refresh'));
        });
      });
    });
  }

  /* filter tabs */
  root.querySelectorAll('.mwl-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      root.querySelectorAll('.mwl-tab').forEach(function(t) { t.classList.remove('on'); });
      tab.classList.add('on');
      var filter = tab.getAttribute('data-filter');
      gridEl.querySelectorAll('.mwl-card').forEach(function(card) {
        var show = true;
        if (filter === 'in_stock')  show = card.getAttribute('data-available') === '1';
        if (filter === 'on_sale')   show = card.getAttribute('data-sale') === '1';
        card.style.display = show ? '' : 'none';
      });
    });
  });

  /* share */
  var shareBtn = document.getElementById('wl-share');
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      if (navigator.share) {
        navigator.share({ title: 'My Wishlist', url: window.location.href });
      } else {
        navigator.clipboard.writeText(window.location.href).catch(function() {});
      }
    });
  }

  /* add all to cart */
  var addAllBtn = document.getElementById('wl-add-all');
  if (addAllBtn) {
    addAllBtn.addEventListener('click', function() {
      var items = getWishlist().filter(function(i) { return i.available && i.variant_id; })
        .map(function(i) { return { id: i.variant_id, quantity: 1 }; });
      if (!items.length) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function() {
        document.dispatchEvent(new Event('foxtheme:cart:refresh'));
      });
    });
  }

  /* listen for external wishlist changes (e.g. from product cards) */
  document.addEventListener('aigo:wishlist:updated', render);

  render();
})();

  } catch(e) { console.error(e); }
})();
})();
